import {Deserialize, ISerializable, Serialize} from 'cerialize';
import {RsvpQuestion} from '../../models/rsvp-question';
import {RsvpMultipleChoiceQuestion} from '../../models/rsvp-multiple-choice-question';
import {RsvpOpenQuestion} from '../../models/rsvp-open-question';

export const RsvpQuestionTransformer: ISerializable = {
  Serialize(value: RsvpQuestion): string {
    return Serialize(value);
  },
  Deserialize(json: any): any {
    if (json) {
      if (Array.isArray(json)) {
        return json.map(this.Deserialize);
      }
      if (json.type === 'RsvpMultipleChoiceQuestion') {
        return Deserialize(json, RsvpMultipleChoiceQuestion);
      }
      if (json.type === 'RsvpOpenQuestion') {
        return Deserialize(json, RsvpOpenQuestion);
      }
    }
    return null;
  }
};
